import getTransitionProperty from '@opten/animation/get-transition-property';
import hasClass from '@opten/dom/has-class';

export class CookieBanner {

	private cookieBanner: HTMLElement;
	private acceptButton: HTMLElement;
	private header: HTMLElement;

	constructor() {

		this.cookieBanner = document.getElementById('cookie-banner');
		this.acceptButton = document.getElementById('cookie-banner-accept');
		this.header = document.getElementById('header');

		this.init();
	}

	private init() {
		window.addEventListener('resize', () => this.setHeader());
		const showBanner = this.showCookieBanner();
		if (showBanner) {
			this.cookieBanner.style.display = 'block';
			this.acceptButton.addEventListener('click', () => {
				this.createCookie(window.cookieName, window.cookieValue, window.cookieDuration);
				this.cookieBanner.parentNode.removeChild(this.cookieBanner);
				this.header.style.top = '0px';
			});

			this.setHeader();
		} else {
			this.cookieBanner.style.display = 'none';
		}
	}

	private showCookieBanner(name?: string): boolean {
		const nameEQ = 'cookiesAccepted=';
		const ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1, c.length);
			}

			if (c.indexOf(nameEQ) === 0) {
				return c.substring(nameEQ.length, c.length) != 'true';
			}
		}

		return true;
	}

	private createCookie(name: string, value: string, days: string) {
		document.cookie = 'cookiesAccepted=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
	}

	private setHeader() {
		this.header.style[getTransitionProperty()] = 'none';
		this.header.style.top = document.getElementById('cookie-banner').offsetHeight + 'px';
		setTimeout(() => {
			this.header.style[getTransitionProperty()] = '';
		}, 100); // hack
	}


	public cookiebannerFixTop() {
		var header = document.getElementById("cookie-banner");
		// var body = document.getElementsByTagName("body");
		console.log(hasClass(document.body, 'is--navigation-open'));

			if (hasClass(document.body, 'is--navigation-open')) {
					header.classList.add("sticky");
					this.cookieBanner.style.position = 'fixed';
					console.log(hasClass(document.body, 'is--navigation-open'));
					
			} else { 
				header.classList.remove("sticky");
 			}
	}
}






// window.onscroll = function() {myFunction()};

// var header = document.getElementById("cookie-banner");
// var sticky = header.offsetTop;

// function myFunction() {
// 	if (window.pageYOffset > sticky) {
// 	header.classList.add("sticky");
// 	} else {
// 	header.classList.remove("sticky");
// 	}
// }
